<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :onLoaded="onLoaded"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
            :expandedOptions="{
                enabled: true,
                allowExpandingAll: true,
                template: 'student-attendance-scans',
            }"
        ></dx-grid>

        <v-dialog persistent v-model="removeCardDialog" max-width="400">
            <v-card class="pa-2">
                <div v-if="selected.length">
                    <v-card-title class="text-warning headline"
                        >Are You Sure?</v-card-title
                    >
                    <v-card-text class="mb-3 py-0">
                        You will be removing cards from the selected
                        {{ selected.length }} students
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="removeCardDialog = false"
                            >Close</v-btn
                        >
                        <v-btn
                            :loading="processing"
                            color="success"
                            @click="removeCards()"
                            >Remove</v-btn
                        >
                    </v-card-actions>
                </div>
                <div v-else>
                    <v-card-text class="my-3 py-0 font-weight-medium">
                        Please select students with card numbers
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="removeCardDialog = false"
                            >Close</v-btn
                        >
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="cardDialog" max-width="400">
            <v-card class="pa-3">
                <v-layout row justify-space-between>
                    <v-card-title class="headline pl-0 pt-0"
                        >Add Card</v-card-title
                    >
                    <v-btn color="success" small @click="openPointsDialog"
                        >Add points</v-btn
                    >
                </v-layout>
                <div class="mb-2">
                    {{ clickedRow.hebName + " " + clickedRow.lastNameH }}
                </div>
                <v-text-field
                    class="mx-1"
                    v-model="newCardNum"
                    label="Card Number"
                    ref="newCardNum"
                    :rules="[rules.required, rules.min, rules.max]"
                ></v-text-field>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="cardDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveCard()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="addPointsDialog" max-width="300">
            <v-card class="pa-3">
                <v-layout row justify-space-between>
                    <v-card-title class="headline pl-0 pt-0"
                        >Add Points</v-card-title
                    >
                </v-layout>
                <div class="mb-2">
                    {{ clickedRow.hebName + " " + clickedRow.lastNameH }}
                </div>
                <v-text-field
                    class=""
                    v-model="addPoints"
                    label="Points"
                    type="number"
                    ref="addPoints"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-select
                    :items="pointTypes"
                    v-model="pointsType"
                    label="Points Type"
                    ref="pointsType"
                    :rules="[rules.required]"
                ></v-select>
                <v-text-field
                    class=""
                    v-model="addPointsNote"
                    label="Note"
                ></v-text-field>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="addPointsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="savePoints()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="confirmCardDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Are You Sure?</v-card-title
                >
                <div class="font-weight-medium mb-2">
                    This card number is already registered on another student,
                    Are you sure you want to assign this card to
                    {{ this.getStudentName() }} ?
                </div>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="confirmCardDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="save()"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="quickAddCardDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Quick Add Card</v-card-title
                >
                <div class="mb-2">
                    {{ quickAddCard.hebName + " " + quickAddCard.lastNameH }}
                </div>
                <v-text-field
                    class="mx-1"
                    v-model="quickAddCard.quickStudentID"
                    label="Student ID"
                    ref="quickStudentID"
                    :rules="[rules.required, rules.studentIDLength]"
                    @keyup.stop.native="onStudentIDEntered($event.target.value)"
                ></v-text-field>
                <v-text-field
                    class="mx-1"
                    v-model="quickAddCard.quickNewCardNum"
                    label="Card Number"
                    ref="quickNewCardNum"
                    :rules="[rules.required, rules.min, rules.max]"
                    @change="quickSaveCard"
                ></v-text-field>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="quickAddCardDialog = false"
                        >Close</v-btn
                    >
                    <!-- <v-btn
                        :loading="processing"
                        color="success"
                        @click="quickSaveCard()"
                    >
                        Save
                    </v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="absentReportDialog"
            :max-width="showDetentionModal ? 1200 : 450"
        >
            <v-card class="pa-3">
                <div v-if="!showDetentionModal">
                    <v-card-title class="headline pl-0 pt-0"
                        >Absent Report</v-card-title
                    >

                    <v-date-picker
                        style="border: 2px solid #4caf50; border-radius: unset;"
                        v-model="selectedDates"
                        multiple
                        width="390"
                        class="mb-3"
                        @input="selectDate"
                    ></v-date-picker>
                    <v-layout row>
                        <v-select
                            multiple
                            label="Branch"
                            v-model="selectedBranches"
                            :items="branches"
                            class="mr-2"
                            style="width: 30%;"
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0" small>
                                    <span>{{ item }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 1"
                                    class="grey--text caption"
                                    style="margin-bottom:0;padding-bottom:0;"
                                    >(+{{
                                        selectedBranches.length - 1
                                    }}
                                    others)</span
                                >
                            </template>
                        </v-select>
                        <v-select
                            style="width: 50%;"
                            v-model="selectedScanTypes"
                            :items="scanTypes"
                            class="mr-3"
                            label="Type"
                            clearable
                            multiple
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0" small>
                                    <span>{{ item }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 1"
                                    class="grey--text caption"
                                    style="margin-bottom:0;padding-bottom:0;"
                                    >(+{{
                                        selectedScanTypes.length - 1
                                    }}
                                    others)</span
                                >
                            </template>
                        </v-select>
                    </v-layout>
                    <v-text-field
                        class="mr-3"
                        type="number"
                        label="Count"
                        v-model="missingCount"
                        color="success"
                        :min="1"
                    ></v-text-field>

                    <v-checkbox
                        class="my-0"
                        label="Only Include After Last Detention Date"
                        v-model="showAfterDetention"
                        color="success"
                    ></v-checkbox>

                    <v-card-actions class="mx-0 px-2 pb-3 mt-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="closeAbsentReportDialog"
                            >Close</v-btn
                        >
                        <v-btn
                            :loading="processing"
                            color="success"
                            @click="loadAbsentReport()"
                        >
                            {{
                                absentReportProcessed ? "Reload" : "Load Report"
                            }}
                        </v-btn>
                    </v-card-actions>

                    <div v-if="absentReportProcessed" class="text-xs-center">
                        <v-divider></v-divider>
                        <div class="mr-2 pt-3 mb-2 font-weight-medium">
                            Total Absent Students:
                            <span class="font-weight-light">{{
                                absentReports.length
                            }}</span>
                        </div>

                        <download-excel
                            v-if="absentReports.length"
                            :fields="exportFields()"
                            :name="getExportFileName()"
                            :before-generate="() => (isExporting = true)"
                            :before-finish="() => (isExporting = false)"
                            :fetch="exportToExcel"
                            type="xlsx"
                        >
                            <v-btn
                                small
                                class="mt-0 ml-1"
                                color="success"
                                :loading="isExporting"
                                >Export Report</v-btn
                            >
                        </download-excel>

                        <v-btn
                            color="success"
                            small
                            v-if="absentReports.length"
                            @click="showDetentionModal = true"
                        >
                            Setup Detention
                        </v-btn>
                    </div>
                </div>
                <div v-if="showDetentionModal">
                    <v-card-title class="headline pl-0 pt-0"
                        >Setup Detention</v-card-title
                    >
                    <v-layout row>
                        <v-btn
                            small
                            color="success"
                            @click="toggleAllStudents"
                            >{{
                                selectedMissingStudents.length
                                    ? "Unselect All"
                                    : "Select All"
                            }}</v-btn
                        >
                        <div
                            class="pt-3 pl-2"
                            v-if="selectedMissingStudents.length"
                        >
                            {{ selectedMissingStudents.length }} Students
                            Selected
                        </div>
                        <v-spacer></v-spacer>
                        <v-text-field
                            style="max-width: 300px;"
                            v-model="searchMissingStudents"
                            append-icon="mdi-search"
                            label="Search"
                            single-line
                            clearable
                            hide-details
                        ></v-text-field>
                    </v-layout>
                    <v-data-table
                        v-model="selectedMissingStudents"
                        :headers="missingStudentsHeaders"
                        :items="absentReports"
                        item-key="studentID"
                        class="elevation-0"
                        :search="searchMissingStudents"
                        :rows-per-page-items="[9, 15, 20]"
                    >
                        <!-- <template v-slot:headers="props">
                            <tr>
                                <th>
                                    <v-checkbox
                                        :input-value="props.all"
                                        :indeterminate="props.indeterminate"
                                        primary
                                        hide-details
                                        @click.stop="toggleAllParents"
                                        color="success"
                                    ></v-checkbox>
                                </th>
                                <th
                                    v-for="header in props.headers"
                                    :key="header.text"
                                    class="text-xs-left"
                                >
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template> -->
                        <template v-slot:items="props">
                            <tr
                                :active="props.selected"
                                @click="props.selected = !props.selected"
                            >
                                <td>
                                    <v-checkbox
                                        :input-value="props.selected"
                                        color="success"
                                        primary
                                        hide-details
                                    ></v-checkbox>
                                </td>
                                <td>{{ props.item.studentID }}</td>
                                <td>
                                    {{ props.item.lastName }}
                                </td>
                                <td>
                                    {{ props.item.firstName }}
                                </td>
                                <td>
                                    {{ props.item.lastNameHebrew }}
                                </td>
                                <td>
                                    {{ props.item.firstNameHebrew }}
                                </td>
                                <td>{{ props.item.branch }}</td>
                                <td>{{ props.item.grade }}</td>
                                <td>{{ props.item.section }}</td>
                                <td>{{ props.item.dateList }}</td>
                            </tr>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ searchMissingStudents }}"
                                found no results.
                            </v-alert>
                        </template>
                    </v-data-table>

                    <v-card-actions class="mx-0">
                        <v-spacer></v-spacer>
                        <v-menu
                            v-model="datePickerMenu"
                            :close-on-content-click="false"
                            offset-y
                            full-width
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    class="pb-2 width-290 mr-2"
                                    v-model="detentionDate"
                                    :value="detentionDate"
                                    label="Detention Date"
                                    hide-details
                                    readonly
                                    ref="scanDate"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="detentionDate"
                            ></v-date-picker>
                        </v-menu>
                        <v-btn
                            color="default"
                            dark
                            @click="showDetentionModal = false"
                        >
                            Back
                        </v-btn>
                        <v-btn
                            :loading="processing"
                            color="success"
                            @click="saveDetention"
                        >
                            Save Detention
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card></v-dialog
        >

        <v-dialog v-model="absentSumReportDialog" max-width="450">
            <v-card class="pa-3">
                <div>
                    <v-card-title class="headline pl-0 pt-0"
                        >Attendance Summery Report</v-card-title
                    >

                    <v-date-picker
                        style="border: 2px solid #4caf50; border-radius: unset;"
                        v-model="selectedDates"
                        multiple
                        width="390"
                        class="mb-3"
                        @input="selectDate"
                    ></v-date-picker
                    ><v-select
                        multiple
                        label="Branch"
                        v-model="selectedBranches"
                        :items="branches"
                        class="mr-3"
                    ></v-select>

                    <v-card-actions class="mx-0 px-2 pb-3 mt-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="closeAbsentSumReportDialog"
                            >Close</v-btn
                        >
                        <v-btn
                            :loading="processing"
                            color="success"
                            @click="loadAbsentSumReport()"
                        >
                            {{
                                absentSumReportProcessed
                                    ? "Reload"
                                    : "Load Report"
                            }}
                        </v-btn>
                    </v-card-actions>

                    <div v-if="absentSumReportProcessed" class="text-xs-center">
                        <v-divider></v-divider>
                        <div class="mr-2 pt-3 mb-2 font-weight-medium">
                            Total Students:
                            <span class="font-weight-light">{{
                                absentSumReports.length
                            }}</span>
                        </div>

                        <download-excel
                            v-if="absentSumReports.length"
                            :fields="exportSumFields()"
                            name="Attendance Summery Report"
                            :before-generate="() => (isExporting = true)"
                            :before-finish="() => (isExporting = false)"
                            :fetch="exportSumReportToExcel"
                            type="xlsx"
                        >
                            <v-btn
                                small
                                class="mt-0 ml-1"
                                color="success"
                                :loading="isExporting"
                                >Export Report</v-btn
                            >
                        </download-excel>
                    </div>
                </div>
            </v-card></v-dialog
        >
    </div>
</template>

<script>
import moment from "moment";
import { groupBy, toISOLocal } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Student Attendance Cards",
        url: "",
        userBranch: "",
        actions: [],
        removeCardDialog: false,
        selected: [],
        processing: false,
        cardDialog: false,
        confirmCardDialog: false,
        absentReportDialog: false,
        absentReports: [],

        absentSumReportDialog: false,
        absentSumReportProcessed: false,
        absentSumReports: [],

        isExporting: false,
        absentReportProcessed: false,
        absentSumReportProcessed: false,
        newCardNum: "",
        clickedRow: {},

        quickAddCardDialog: false,
        quickAddCard: {
            hebName: "",
            lastNameH: "",
            quickStudentID: "",
            quickNewCardNum: "",
        },

        addPointsDialog: false,
        addPoints: "",
        addPointsNote: "",
        pointsType: "Used",
        pointTypes: ["Earned", "Used"],

        selectedDates: [],
        sortedDates: [],
        selectedBranches: [],
        branches: [],
        missingCount: 5,
        showAfterDetention: false,
        showDetentionModal: false,

        detentionDate: "",
        datePickerMenu: false,

        selectedScanTypes: [
            "MISSING",
            "MISSING BEFORE DETENTION",
            "ABSENT",
            "Absent-Day",
            "Abset-Brekfast",
            "Absent Breakfast Permission",
            "Late",
        ],
        scanTypes: [
            "MISSING",
            "MISSING BEFORE DETENTION",
            "ABSENT",
            "Absent-Day",
            "Abset-Brekfast",
            "Absent Breakfast Permission",
            "Late",
        ],

        selectedMissingStudents: [],
        searchMissingStudents: "",
        missingStudentsHeaders: [
            {
                text: "",
                value: "selected",
                sortable: false,
            },
            {
                text: "Student ID",
                value: "studentID",
            },
            { text: "Last Name", value: "lastName" },
            { text: "First Name", value: "firstName" },
            { text: "Last Name Hebrew", value: "lastNameHebrew" },
            { text: "First Name Hebrew", value: "firstNameHebrew" },
            { text: "Branch", value: "branch" },
            { text: "Grade", value: "grade" },
            { text: "Section", value: "section" },
            { text: "Dates", value: "dateList" },
        ],

        rules: {
            required: (value) => !!value || "Required.",

            max: (value) => {
                return (
                    !value || value.length < 13 || `Maximum characters is 12`
                );
            },
            min: (value) => {
                return !value || value.length >= 8 || `Minimum characters is 8`;
            },
            studentIDLength: (value) => {
                return !value || value.length == 9 || `Must be 9 characters`;
            },
        },

        columns: [
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Heb Name",
                field: "hebName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Heb Last Name",
                field: "lastNameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Eng Name",
                field: "engName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "familyID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Points Balance",
                field: "pointsBalance",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Points Earned",
                field: "pointsEarned",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Points Used",
                field: "pointsUsed",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Number",
                field: "cardNum",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "DOB",
                field: "dob",
                type: "date",
                format: "MM/dd/yyyy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Heb",
                field: "teacherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacherName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.loadBranches();
    },
    methods: {
        beforeSetupGrid() {
            this.actions.push({
                text: "Remove Cards",
                action: this.openRemoveCards,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Absnet Report",
                action: this.openAbsnetReportDialog,
            });

            this.actions.push({
                text: "Attendance Summery Report",
                action: this.openAbsentSumReportDialog,
            });

            this.actions.push({
                text: "Quick Add Cards",
                action: this.openQuickAddCardDialog,
            });

            this.userBranch = this.$store.state.authentication.branch;

            this.url =
                "studentAttendanceCards?" +
                (this.userBranch != "null"
                    ? "branch=" + this.userBranch
                    : "branch=");
        },
        openRemoveCards() {
            const selected = this.$refs.grid.getSelectedRowsData();

            this.selected = selected.filter((s) => s.cardNum != "N/A");

            this.removeCardDialog = true;
        },
        openAbsnetReportDialog() {
            this.detentionDate = toISOLocal(new Date(moment())).substr(0, 10);

            this.absentReportDialog = true;
        },
        openAbsentSumReportDialog() {
            this.absentSumReportDialog = true;
        },
        async loadBranches() {
            const branches = await this.$http.get("api/students/getBranchList");

            this.branches = branches;

            if (this.userBranch && this.userBranch != "null") {
                this.branches = this.userBranch.split(",");
                this.selectedBranches = this.branches;
            } else {
                this.selectedBranches = ["2417"];
            }
        },
        openQuickAddCardDialog() {
            this.quickAddCardDialog = true;
            this.quickAddCard.quickStudentID = "";
            this.quickAddCard.quickNewCardNum = "";

            this.$refs.quickStudentID.resetValidation();
            this.$refs.quickNewCardNum.resetValidation();

            setTimeout(() => {
                this.$refs.quickStudentID.focus();
            }, 100);
        },
        // async onRowClicked(row) {
        //     this.$router.push({
        //         name: "Account View",
        //         params: {
        //             id: row.utaId,
        //         },
        //     });
        // },
        onLoaded(data) {
            if (!data.length) return;

            data.forEach((d) => (d.playIcon = "mdi-play-circle"));
        },
        async removeCards() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/studentAttendanceCards/removeCards",
                    this.selected.map((s) => s.cardNum),
                );

                this.removeCardDialog = false;
                this.$refs.grid.reloadGrid();
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        onRowClicked(row) {
            this.clickedRow = row;
            this.newCardNum = "";
            this.cardDialog = true;
        },
        openPointsDialog() {
            this.addPoints = "";
            this.addPointsDialog = true;
        },
        async savePoints() {
            if (
                !this.$refs.addPoints.validate(true) ||
                !this.$refs.pointsType.validate(true)
            )
                return;

            try {
                this.processing = true;

                await this.$http.post("api/studentAttendanceCards/AddScan", {
                    cardNum: this.clickedRow.cardNum,
                    studentID: this.clickedRow.studentID,
                    regID: this.clickedRow.regID,
                    points: this.addPoints,
                    enteredBy: this.$store.state.authentication.user,
                    note: this.addPointsNote,
                    pointsType: this.pointsType,
                });

                this.processing = false;
                this.addPointsDialog = false;
                this.cardDialog = false;
                this.$refs.grid.reloadGrid();

                this.$notify({
                    text: "Points Saved",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        async saveCard() {
            if (!this.$refs.newCardNum.validate(true)) return;

            const exist = await this.$http.get(
                "api/studentAttendanceCards/CardNumberExist?cardNumber=" +
                    this.newCardNum +
                    "&studentID=" +
                    this.clickedRow.studentID,
            );

            if (exist) {
                this.confirmCardDialog = true;

                return;
            }

            this.save();
        },
        getStudentName() {
            if (this.quickAddCardDialog) {
                return (
                    this.quickAddCard.hebName +
                    " " +
                    this.quickAddCard.lastNameH
                );
            }

            return this.clickedRow.hebName + " " + this.clickedRow.lastNameH;
        },
        async save() {
            try {
                this.processing = true;

                const isQuickAdd = this.quickAddCardDialog;

                await this.$http.post("api/studentAttendanceCards/addCard", {
                    studentID: isQuickAdd
                        ? this.quickAddCard.quickStudentID
                        : this.clickedRow.studentID,
                    cardNumber: isQuickAdd
                        ? this.quickAddCard.quickNewCardNum
                        : this.newCardNum,
                });

                this.processing = false;
                this.cardDialog = false;
                this.confirmCardDialog = false;
                this.$refs.grid.reloadGrid();
                this.clickedRow = {};

                this.$notify({
                    text: "Card Added",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        async onStudentIDEntered(value) {
            if (value.length != 9) return;

            const student = await this.$http.get(
                "api/studentAttendanceCards/getStudent?studentID=" + value,
            );

            if (!student) {
                return this.$notify({
                    text: "Student ID Not In System",
                    group: "notification",
                    type: "error",
                });
            }

            this.quickAddCard.hebName = student.hebName;
            this.quickAddCard.lastNameH = student.lastNameH;

            this.$refs.quickNewCardNum.focus();
        },
        async quickSaveCard() {
            if (!this.quickAddCard.quickStudentID) {
                return this.$notify({
                    text: "Missing Student ID",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.$refs.quickNewCardNum.validate(true)) return;

            const exist = await this.$http.get(
                "api/studentAttendanceCards/CardNumberExist?cardNumber=" +
                    this.quickAddCard.quickNewCardNum +
                    "&studentID=" +
                    this.quickAddCard.quickStudentID,
            );

            if (exist) {
                console.log(this.quickAddCard);
                this.confirmCardDialog = true;

                return;
            }

            if (!this.$refs.quickStudentID.validate(true)) return;

            try {
                this.processing = true;

                await this.$http.post("api/studentAttendanceCards/addCard", {
                    studentID: this.quickAddCard.quickStudentID,
                    cardNumber: this.quickAddCard.quickNewCardNum,
                });

                this.processing = false;

                this.quickAddCard.quickStudentID = "";
                this.quickAddCard.quickNewCardNum = "";
                this.quickAddCard.hebName = "";
                this.quickAddCard.lastNameH = "";
                this.$refs.quickStudentID.resetValidation();

                setTimeout(() => {
                    this.$refs.quickNewCardNum.resetValidation();
                }, 100);

                setTimeout(() => {
                    this.$refs.quickStudentID.focus();
                }, 100);

                this.$refs.grid.reloadGrid();

                this.$notify({
                    text: "Card Added",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        selectDate(value) {
            this.selectedDates = value;
        },
        closeAbsentReportDialog() {
            this.absentReportDialog = false;
            this.absentReportProcessed = false;
            this.absentReports = [];
            this.selectedBranches = [];
            this.selectedDates = [];
            this.missingCount = 5;
            this.showAfterDetention = false;
        },
        closeAbsentSumReportDialog() {
            this.absentSumReportDialog = false;
            this.absentSumReportProcessed = false;
            this.absentSumReports = [];
            this.selectedBranches = [];
            this.selectedDates = [];
        },
        async loadAbsentReport() {
            if (!this.selectedBranches.length) {
                return this.$notify({
                    text: "Please Select Branch",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.selectedDates.length) {
                return this.$notify({
                    text: "Please Select Date",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.missingCount) {
                return this.$notify({
                    text: "Please Enter Missing Count",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.absentReportProcessed = false;

                this.processing = true;

                const response = await this.$http.post(
                    "api/studentAttendanceCards/getAbsentStudentsReport",
                    {
                        dates: this.selectedDates,
                        branches: this.selectedBranches,
                        missingCount: this.missingCount,
                        showAfterDetention: this.showAfterDetention,
                        scanTypes: this.selectedScanTypes,
                    },
                );

                const groupedByStudent = groupBy(
                    response.students,
                    "studentID",
                );

                this.sortedDates = response.dates;

                this.absentReports = Object.keys(groupedByStudent).map(
                    (key) => {
                        const studentList = groupedByStudent[key]
                            ? groupedByStudent[key]
                            : [];
                        const student = studentList[0];

                        const data = {
                            studentID: student.studentID,
                            cardNum: student.cardNum,
                            regID: student.regID,
                            lastName: student.lastName,
                            firstName: student.engName,
                            lastNameHebrew: student.lastNameH,
                            firstNameHebrew: student.hebName,
                            branch: student.branch,
                            grade: student.class,
                            section: student.section,
                            dates: studentList.map((s) =>
                                moment(s.date).format("MM-DD-YYYY"),
                            ),
                            dateList: studentList
                                .map((s) => moment(s.date).format("MM-DD-YYYY"))
                                .join(","),
                            lastDetentionDate: student.lastDetentionDate
                                ? moment(student.lastDetentionDate).format(
                                      "MM-DD-YYYY",
                                  )
                                : "",
                            studentList: studentList.map((s) => {
                                s.date = moment(s.date).format("MM-DD-YYYY");

                                return s;
                            }),
                        };

                        return data;
                    },
                );

                this.absentReports.forEach((student) => {
                    this.sortedDates
                        .map((d) => moment(d).format("MM-DD-YYYY"))
                        .forEach((date) => {
                            if (
                                !student.studentList.find((s) => s.date == date)
                            ) {
                                return;
                            }
                            student[date] = student.studentList.find(
                                (s) => s.date == date,
                            ).scanType;
                        });
                });

                this.absentReportProcessed = true;
                this.processing = false;
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        async loadAbsentSumReport() {
            if (!this.selectedBranches.length) {
                return this.$notify({
                    text: "Please Select Branch",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.selectedDates.length) {
                return this.$notify({
                    text: "Please Select Date",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.absentSumReportProcessed = false;

                this.processing = true;

                const response = await this.$http.post(
                    "api/studentAttendanceCards/GetStudentAbsenceSumReport",
                    {
                        dates: this.selectedDates,
                        branches: this.selectedBranches,
                    },
                );

                this.absentSumReports = response;

                this.absentSumReportProcessed = true;
                this.processing = false;
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        getExportFileName() {
            return "Absent Report";
        },
        exportFields() {
            let fields = {
                StudentID: {
                    field: "studentID",
                    callback: (value) => {
                        return `${JSON.stringify(value.trim())}`;
                    },
                },
                LastName: "lastName",
                FirstName: "firstName",
                LastNameHebrew: "lastNameHebrew",
                FirstNameHebrew: "firstNameHebrew",
                Branch: "branch",
                Grade: "grade",
                Section: "section",
                LastDetentionDate: "lastDetentionDate",
            };

            this.sortedDates.forEach((date) => {
                const formattedDate = moment(date).format("MM-DD-YYYY");

                fields[formattedDate] = formattedDate;
            });

            return fields;
        },
        async exportToExcel() {
            return this.absentReports;
        },
        exportSumReportToExcel() {
            return this.absentSumReports;
        },
        exportSumFields() {
            let fields = {
                StudentID: {
                    field: "studentID",
                    callback: (value) => {
                        return `${JSON.stringify(value.trim())}`;
                    },
                },
                LastName: "lastName",
                FirstName: "engName",
                LastNameHebrew: "lastNameH",
                FirstNameHebrew: "hebName",
                Grade: "class",
                Section: "section",
                DateFrom: "dateFrom",
                DateTo: "dateTo",
                Details: "details",
            };

            if (this.absentSumReports.some((a) => a.absentSum > 0)) {
                fields["AbsentSum"] = "absentSum";
            }

            if (this.absentSumReports.some((a) => a.absentBreakfastSum > 0)) {
                fields["AbsentBreakfastSum"] = "absentBreakfastSum";
            }

            if (this.absentSumReports.some((a) => a.absentDaysSum > 0)) {
                fields["AbsentDaysSum"] = "absentDaysSum";
            }

            if (this.absentSumReports.some((a) => a.lateSum > 0)) {
                fields["LateSum"] = "lateSum";
            }

            return fields;
        },
        toggleAllStudents() {
            if (this.selectedMissingStudents.length)
                this.selectedMissingStudents = [];
            else this.selectedMissingStudents = this.absentReports.slice();
        },
        async saveDetention() {
            if (!this.selectedMissingStudents.length) {
                return this.$notify({
                    text: "No Students Selected",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/studentAttendanceCards/saveDetention",
                    {
                        students: this.selectedMissingStudents,
                        user: this.$store.state.authentication.user,
                        date: moment(this.detentionDate).format("YYYY-MM-DD"),
                    },
                );

                console.log(response);

                this.processing = false;
                this.showDetentionModal = false;
                this.absentReportDialog = false;

                this.$notify({
                    text: "Detention Saved",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.width-290 {
    width: 290px;
    max-width: 290px;
    min-width: 290px;
}
</style>
